<div class="py-5 wow fadeIn footer-sec" data-wow-delay="0.2s">
    <div class="container">
        <div class="row align-items-start">
            <!-- Colonne Logo et description -->
            <div class="col-12 col-md-4 mb-4 mb-md-0">
                <div class="d-flex align-items-center mb-3">
                    <!-- Image gauche -->
                      <img [src]="logo"
                          (error)="onImageError($event)"
                          alt="Armoirie"
                          class="logo">
                   
                </div>
                <!-- <p class="small">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
                    incididunt ut labore et dolore magna aliqua.</p> -->
                <div class="social-icons mt-3">
                    <a [href]="this.configMairie?.facebook?.value || '-'" target="_blank" class="me-3" aria-label="Facebook"><i class="fab fa-facebook"></i></a>
                    <a [href]="this.configMairie?.linkedin?.value || '-'" target="_blank" class="me-3" aria-label="LinkedIn"><i class="fab fa-linkedin"></i></a>
                </div>
            </div>

            <!-- Colonne Liens Utiles -->
            <div class="col-12 col-md-4 mb-4 mb-md-0">
                <h5 class="fw-bold text-light mb-3">Menu</h5>
                <ul class="list-unstyled">
                   <li class="mb-2"><a style="font-size: 18px;" routerLink="/contact" href="javascript:void(0);"
                            class="text-white text-decoration-none hover-underline">Accueil</a></li>
                    <li class="mb-2"><a style="font-size: 18px;" routerLink="/contact" href="javascript:void(0);"
                            class="text-white text-decoration-none hover-underline">Contact</a></li>
                  
                </ul>
            </div>

            <!-- Colonne Contact -->
            <div class="col-12 col-md-4 mb-4 mb-md-0">
                <h5 class="fw-bold text-light mb-3">Contactez-nous</h5>
                <div class="mb-3">
                    <p style="font-size: 18px;" class="mb-1"><i class="fas fa-phone me-2"></i>{{ contact|| '-'}}</p>
                    <p style="font-size: 18px;" class="mb-1"><i class="fas fa-envelope me-2"></i>{{ email|| '-'}}
                    </p>
                    <!-- <p style="font-size: 18px;" class="mb-1"><i class="fas fa-map-marker-alt me-2"></i>Adresse complète,
                        Ville, Pays</p> -->
                </div>
            </div>

        </div>

        <!-- Ligne de copyright -->
        <div class="row mt-4 pt-3 border-top border-light">
            <div class="col-12">
                <div class="d-flex flex-column flex-md-row justify-content-between align-items-center">
                    <small>© 2025 - Tous droits réservés </small>
                 
                    <p class="fs-6">version 0.9.2</p>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Footer Bar colorée -->
<div class="footer-bar">
    <div class="bar green"></div>
    <div class="bar yellow"></div>
    <div class="bar red"></div>
</div>

<!-- Styles CSS additionnels -->
